import FieldConfig from "../../../proto/field-config"
import FieldEstimate from "../../../generic/estimate/estimate"
import FieldItemModelCalculatedSpentEstimate_TableCell from "./render/table/table-cell"
import {SortDirection} from "../../../../data-structures/sort"
import ItemModelV2 from "../../../../model2/item2/item-model"
import {ItemModelV2_CalculatedValues} from "../../../../model2/item2/calculated/@type"
import FieldItemModelCalculatedSpentEstimate_AggregateCell from "./render/aggregate/aggregate-cell"
import FieldItemModelCalculatedSpentEstimate_ViewSmall from "./render/view-small"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"

export default class FieldItemModelCalculatedSpentEstimate extends FieldEstimate {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel                              = "Spent / Estimate"
        this.label                                  = "Spent / Estimate"
        this.icon                                   = 'i5-time-percent'

        this.hasCalculatedValues                    = true

        this.renderComponents.viewSmall             = FieldItemModelCalculatedSpentEstimate_ViewSmall
        this.renderComponents.tableCell             = FieldItemModelCalculatedSpentEstimate_TableCell
        this.renderComponents.tableCellCalculated   = FieldItemModelCalculatedSpentEstimate_TableCell
        this.renderComponents.aggregateCell         = FieldItemModelCalculatedSpentEstimate_AggregateCell
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [
                (listItem: ItemModelV2) => {
                    let value = 0

                    const dataByAggregateFunc = listItem.calculated.dataByAggregateFunction[this.fieldId]
                    const calculatedValues: ItemModelV2_CalculatedValues = dataByAggregateFunc?.[_.keys(dataByAggregateFunc)[0] as keyof {}] // take first property from dataByAggregateFunc

                    if (listItem.view.isCollapsed &&
                        calculatedValues &&
                        !!calculatedValues?.total?.value &&
                        calculatedValues.total.value != calculatedValues.own) {
                        value = calculatedValues.total.value
                    } else if (calculatedValues?.own) {
                        value = calculatedValues.own
                    } else {
                        //  ????
                    }

                    return value
                }
            ],
            directions  : [sort]
        }
    }

    /** AGGREGATE **/
    getAggregateOptions() {return [
        AggregateFunctionType.TOTAL_SPENT_ESTIMATE,
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.TOTAL_SPENT_ESTIMATE
    }
}
